import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import { useParams } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import Fetch from '../functions/Fetch';
import { useSelector } from 'react-redux';

function List() {
  const sessionSelector = useSelector((state) => { return state.core.session });
  const friendly_url = sessionSelector.pdc_project_friendly_url;

  const paths = {
    endpoint: config.endpoints.backend + 'portal/getalleditals'
  }

  let list = {
    labelTitle: 'Lista de Editais',
    labelTitleButtonAdd: 'Incluir novo Edital',
    fieldsShowOnDelete: ['edital_number'],
    icon: 'fa-clipboard-check',
    filter: {
      friendly_url: friendly_url
    },
    canDownload: true,
    fieldToDownload: 'file',
    columns: [
      {
        name: 'edital_number',
        label: 'Edital',
        width: '15%'
      },
      {
        name: 'document_type',
        label: 'Tipo Doc.',
        width: '15%'
      },
      {
        name: 'limit_date',
        label: 'Data Limite',
        width: '15%'
      },
      {
        name: 'object',
        label: 'Objeto'
      }
    ]
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        canAdd={false}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
        icon={list.icon}
      />
    </div>
  );
}
export default List;
